import { render, staticRenderFns } from "./POPUPASTA.vue?vue&type=template&id=18053e89&scoped=true"
import script from "./POPUPASTA.vue?vue&type=script&lang=ts"
export * from "./POPUPASTA.vue?vue&type=script&lang=ts"
import style0 from "./POPUPASTA.vue?vue&type=style&index=0&id=18053e89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18053e89",
  null
  
)

export default component.exports